import {useMemo, useDebugValue} from 'react';
import {useSelector} from 'react-redux';
import {useResize} from './dom';

/*
    hooks/semantic.jsx

    Hooks with polyphony-specific semantics.
*/

/*
    useBreakpoint
*/

export const useBreakpoint = () => {
    const {width} = useResize();
    const breakpoints = useSelector(s => s.breakpoints);
    const breakpoint = useMemo(() => {
        let w = width;
        let matching = null;
        let px = 0;

        for (let x in breakpoints) {
            const width = parseInt(breakpoints[x]);
            if (w >= width && width >= px) {
                matching = x;
                px = width;
            }
        }

        return matching ? matching : 'default';
    }, [width, ...Object.values(breakpoints)]);
    useDebugValue(breakpoint);
    return breakpoint;
};

/*
    useFeaturedMedia
*/

export const useFeaturedMedia = (overrideMedia) => {
    const bp = useBreakpoint();
    const media = useSelector(s => overrideMedia ? overrideMedia : s.featured_media, (a, b) => a.id !== b.id);
    return media ? media[bp] ? media[bp] : media.default : null;
};

